import React, { useCallback, useState } from 'react';
import { Typography } from '@mui/material';
import { submitForm } from '../../api/forms.api';
import DynamicForm from '../DynamicForm/DynamicForm';
import { FormsProps } from '../../types/forms';
import { useMessage } from '../../hooks/useMessage';
import { useEvents } from '../../hooks/useEvents';
import { useError } from '../../context/error-context';

const AddSingleRowForm = ({ formId, formName, formAllFields, skin }: FormsProps) => {
    const { showMessage, MessageContainer } = useMessage();
    const [ submitting, setSubmitting ] = useState(false);
    const { emit } = useEvents();
    const { showError } = useError();

    const submitFormHandler = async (values: {
        [key: string]: any
    }) => {
        if (!formId) {
            return;
        }

        const formData: {
            form_id: number;
            data: {
                id: string;
                value: any;
            }[];
        } = {
            form_id: +formId,
            data: [],
        };

        Object.keys(values).forEach((key: string) => {
            formData.data.push({ id: key, value: values[key] });
        });

        setSubmitting(true);
        submitForm(formData)
        .then(() => {
            setSubmitting(false);
            showMessage('Your data has been saved!', 'success');
            const payload: {
                [key: string]: any
            } = {};
            formAllFields.forEach(field => {
                const value = formData.data.find(row => row.id === field.id);
                if (value !== undefined) {
                    payload[field.id] = value;
                }
            });
            emit(`REFRESH_FORMS_${formId}`, payload);
            emit(`REFRESH_IFRAMES`, payload);
        })
        .catch((err) => {
            showError({
                code: err.response?.status || 500,
                message: 'API Error',
                description: 'Failed to fetch data',
                showRefresh: true,
            });
        })
        .finally(() => setSubmitting(false));
    };

    const resetFormEmittedData = useCallback(() => {
        emit(`REFRESH_FORMS_${formId}`, {});
    }, [ emit, formId ]);

    return (
        <div style={{ margin: 16 }}>
            <div>
                {skin === 'skin1' && (
                    <>
                        <Typography variant="h4" gutterBottom>{formName || 'Fill in the form'}</Typography>
                        {/*<h4 style={{ margin: '8px auto 16px' }}>*/}
                        {/*    Please fill in the data.*/}
                        {/*</h4>*/}
                    </>
                )}
            </div>
            <DynamicForm
                formId={formId}
                formName={formName}
                config={{ fields: formAllFields }}
                onSubmit={submitFormHandler}
                apiSubmitting={submitting}
                skin={skin}
                shouldSeparateLeaves={skin === 'skin3'}
                resetFormEmittedData={resetFormEmittedData}
            />
            <MessageContainer/>
        </div>
    );
};

export default AddSingleRowForm;